module.exports = __webpack_public_path__ + "img/thumbnail_Blackbuck_m_leucistic.73e4b03a.png";